var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalytics1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 5H5.31251C5.14001 5 5 5.14001 5 5.31251V9.06247C5 9.23497 5.14001 9.37498 5.31251 9.37498H6.5625C6.735 9.37498 6.87501 9.23497 6.87501 9.06247V5.31251C6.87501 5.14001 6.735 5 6.5625 5Z",
    fill: "#36bbc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 6.875H2.81251C2.64001 6.875 2.5 7.01501 2.5 7.18751V9.06249C2.5 9.23499 2.64001 9.37499 2.81251 9.37499H4.0625C4.235 9.37499 4.37501 9.23499 4.37501 9.06249V7.18751C4.37498 7.01501 4.235 6.875 4.0625 6.875Z",
    fill: "#36bbc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0625 3.125H7.81251C7.64001 3.125 7.5 3.26501 7.5 3.43751V9.06245C7.5 9.23495 7.64001 9.37496 7.81251 9.37496H9.0625C9.235 9.37496 9.37501 9.23495 9.37501 9.06245V3.43751C9.37501 3.26501 9.235 3.125 9.0625 3.125Z",
    fill: "#36bbc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8167 13.9332L11.0862 10.2026C11.9687 9.12514 12.4999 7.7489 12.4999 6.25017C12.4999 2.80396 9.69617 0.000244141 6.24996 0.000244141C2.80374 0.000244141 0 2.80396 0 6.25017C0 9.69639 2.80371 12.5001 6.24993 12.5001C7.74865 12.5001 9.12489 11.9689 10.2024 11.0864L13.933 14.817C14.0549 14.9388 14.2149 15.0001 14.3749 15.0001C14.5349 15.0001 14.6949 14.9388 14.8167 14.817C15.0611 14.5726 15.0611 14.1776 14.8167 13.9332ZM6.24993 11.2501C3.49309 11.2501 1.24997 9.00704 1.24997 6.25017C1.24997 3.49331 3.49309 1.25021 6.24993 1.25021C9.00677 1.25021 11.2499 3.49334 11.2499 6.25017C11.2499 9.00701 9.0068 11.2501 6.24993 11.2501Z",
    fill: "#36bbc2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics1);
export default __webpack_public_path__ + "static/media/analytics 1.ce68becaba84bbaf1cb3f84b25515fa9.svg";
export { ForwardRef as ReactComponent };